<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    @if (cart) {
      <ion-title>
        @if (!cart.shipping_address) {
          <span>Add shipping</span>
        }
        @if (cart.shipping_address) {
          <span>Update shipping</span>
        }
      </ion-title>
    }
    <ion-buttons slot="end">
      <ion-button (click)="update()">
        <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

</ion-header>

<ion-content>

  <ion-grid class="form">
    <ion-row>
      <ion-col>
        <ion-grid class="fieldset">
          <ion-row>
            <ion-col>
              <ion-input #shipping_price_input type="tel" inputmode="decimal" maxlength="10" label="Shipping price" labelPlacement="stacked" fill="outline" [(ngModel)]="shipping['price']"></ion-input>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              @if (shipping['delivery_date']) {
                <ion-input class="modal-input" readonly="true" labelPlacement="stacked" fill="outline" value={{formatted_delivery_date}} (click)="presentDateTimePickerModal()">
                  <div slot="label">Delivery date<ion-text class="optional">optional</ion-text></div>
                </ion-input>
              }
              @if (!shipping['delivery_date']) {
                <ion-input class="modal-input" readonly="true" labelPlacement="stacked" fill="outline" (click)="presentDateTimePickerModal()">
                  <div slot="label">Delivery date<ion-text class="optional">optional</ion-text></div>
                </ion-input>
              }
            </ion-col>
          </ion-row>
        </ion-grid>
        <ion-grid class="fieldset">
          <ion-row class="ion-align-items-center">
            <ion-col>
              <h3>Shipping address</h3>
            </ion-col>
            @if (online && cart.person) {
              <ion-col size="auto">
                <a (click)="presentAddressPickerModal()" class="clickable-text">
                  <fa-icon [icon]="['far', 'address-book']" style="margin-right: 5px;"></fa-icon>Address book
                </a>
              </ion-col>
            }
          </ion-row>
          <ion-row>
            <ion-col>
              @if (address_requires_first_name) {
                <ion-input type="text" inputmode="text" maxlength="50" label="First name" labelPlacement="stacked" fill="outline" [(ngModel)]="shipping['address_first_name']"></ion-input>
              }
              @if (!address_requires_first_name) {
                <ion-input type="text" inputmode="text" maxlength="50" labelPlacement="stacked" fill="outline" [(ngModel)]="shipping['address_first_name']">
                  <div slot="label">First name<ion-text class="optional">optional</ion-text></div>
                </ion-input>
              }
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              @if (address_requires_last_name) {
                <ion-input type="text" inputmode="text" maxlength="50" label="Last name" labelPlacement="stacked" fill="outline" [(ngModel)]="shipping['address_last_name']"></ion-input>
              }
              @if (!address_requires_last_name) {
                <ion-input type="text" inputmode="text" maxlength="50" labelPlacement="stacked" fill="outline" [(ngModel)]="shipping['address_last_name']">
                  <div slot="label">Last name<ion-text class="optional">optional</ion-text></div>
                </ion-input>
              }
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-input type="text" inputmode="text" maxlength="100" labelPlacement="stacked" fill="outline" [(ngModel)]="shipping['address_organisation_title']">
                <div slot="label">Organisation title<ion-text class="optional">optional</ion-text></div>
              </ion-input>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              @if (country) {
                <ion-input class="modal-input" readonly="true" label="Country" labelPlacement="stacked" fill="outline" value={{country.title}} (click)="presentCountryPickerModal()"></ion-input>
              }
              @if (!country) {
                <ion-input class="modal-input" readonly="true" label="Country" labelPlacement="stacked" fill="outline" (click)="presentCountryPickerModal()"></ion-input>
              }
            </ion-col>
          </ion-row>
          @if (country) {
            <ion-row>
              <ion-col>
                <ion-button class="find-address" fill="outline" expand="block" (click)="presentAddressFinderModal()">
                  <fa-icon [icon]="['far', 'search']" style="margin-right: 5px;"></fa-icon>Find address
                </ion-button>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <ion-input type="text" inputmode="text" maxlength="100" labelPlacement="stacked" fill="outline" [(ngModel)]="shipping['address_premises']">
                  <div slot="label">Unit / Level / Building<ion-text class="optional">optional</ion-text></div>
                </ion-input>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                @if (address_requires_line_1) {
                  <ion-input type="text" inputmode="text" maxlength="100" label="Line 1" labelPlacement="stacked" fill="outline" [(ngModel)]="shipping['address_line_1']"></ion-input>
                }
                @if (!address_requires_line_1) {
                  <ion-input type="text" inputmode="text" maxlength="100" labelPlacement="stacked" fill="outline" [(ngModel)]="shipping['address_line_1']">
                    <div slot="label">Line 1<ion-text class="optional">optional</ion-text></div>
                  </ion-input>
                }
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <ion-input type="text" inputmode="text" maxlength="100" labelPlacement="stacked" fill="outline" [(ngModel)]="shipping['address_line_2']">
                  <div slot="label">Line 2<ion-text class="optional">optional</ion-text></div>
                </ion-input>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                @if (address_requires_locality) {
                  <ion-input type="text" inputmode="text" maxlength="50" label="Town / City" labelPlacement="stacked" fill="outline" [(ngModel)]="shipping['address_locality']"></ion-input>
                }
                @if (!address_requires_locality) {
                  <ion-input type="text" inputmode="text" maxlength="50" labelPlacement="stacked" fill="outline" [(ngModel)]="shipping['address_locality']">
                    <div slot="label">Town / City<ion-text class="optional">optional</ion-text></div>
                  </ion-input>
                }
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                @if (address_has_subdivisions && address_requires_subdivision && address_subdivision_label_changed) {
                  <ion-select cancelText="Close" interface="alert" label="{{address_subdivision_label}}" labelPlacement="stacked" fill="outline" [(ngModel)]="shipping['address_subdivision']">
                    @for (subdivision of subdivisions; track subdivision) {
                      <ion-select-option value="{{subdivision.title}}">{{subdivision.title}}</ion-select-option>
                    }
                  </ion-select>
                }
                @if (address_has_subdivisions && !address_requires_subdivision && address_subdivision_label_changed) {
                  <ion-select cancelText="Close" interface="alert" [interfaceOptions]="{header: address_subdivision_label}" labelPlacement="stacked" fill="outline" [(ngModel)]="shipping['address_subdivision']">
                    <div slot="label">{{address_subdivision_label}}<ion-text class="optional">optional</ion-text></div>
                    @for (subdivision of subdivisions; track subdivision) {
                      <ion-select-option value="{{subdivision.title}}">{{subdivision.title}}</ion-select-option>
                    }
                  </ion-select>
                }
                @if (!address_has_subdivisions && address_subdivision_label_changed) {
                  <ion-input type="text" inputmode="text" maxlength="50" labelPlacement="stacked" fill="outline" [(ngModel)]="shipping['address_subdivision']">
                    <div slot="label">{{address_subdivision_label}}<ion-text class="optional">optional</ion-text></div>
                  </ion-input>
                }
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                @if (address_requires_postal_code) {
                  <ion-input type="text" inputmode="text" maxlength="10" label="{{address_postal_code_label}}" labelPlacement="stacked" fill="outline" [(ngModel)]="shipping['address_postal_code']"></ion-input>
                }
                @if (!address_requires_postal_code) {
                  <ion-input type="text" inputmode="text" maxlength="10" labelPlacement="stacked" fill="outline" [(ngModel)]="shipping['address_postal_code']">
                    <div slot="label">{{address_postal_code_label}}<ion-text class="optional">optional</ion-text></div>
                  </ion-input>
                }
              </ion-col>
            </ion-row>
          }
          <ion-row>
            <ion-col>
              <ion-input type="text" inputmode="text" maxlength="130" labelPlacement="stacked" fill="outline" [(ngModel)]="shipping['address_what3words_address']">
                <div slot="label">what3words address<ion-text class="optional">optional</ion-text></div>
              </ion-input>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-input type="text" inputmode="text" maxlength="100" [counter]="true" labelPlacement="stacked" fill="outline" [(ngModel)]="shipping['address_courier_instructions']">
                <div slot="label">Courier instructions<ion-text class="optional">optional</ion-text></div>
              </ion-input>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              @if (address_requires_mobile_phone_number) {
                <ion-input type="tel" inputmode="tel" maxlength="20" label="Mobile phone number" labelPlacement="stacked" fill="outline" [(ngModel)]="shipping['address_mobile_phone_number']"></ion-input>
              }
              @if (!address_requires_mobile_phone_number) {
                <ion-input type="tel" inputmode="tel" maxlength="20" labelPlacement="stacked" fill="outline" [(ngModel)]="shipping['address_mobile_phone_number']">
                  <div slot="label">Mobile phone number<ion-text class="optional">optional</ion-text></div>
                </ion-input>
              }
            </ion-col>
          </ion-row>
          <!-- NOTE: only allowing user to save to address book if all required shipping address fields are filled reguardless of order_pos settings-->
          @if (online && country && cart.person && (cart.organisation ? permissionService.isPermitted('pos-organisations-shipping-addresses-add-shipping-address') : permissionService.isPermitted('pos-people-shipping-addresses-add-shipping-address')) && (shipping['address_first_name'] && shipping['address_first_name'].length != 0) && (shipping['address_last_name'] && shipping['address_last_name'].length != 0) && (shipping['address_line_1'] && shipping['address_line_1'].length != 0) && (shipping['address_locality'] && shipping['address_locality'].length != 0) && (!country.subdivisions?.length || (shipping['address_subdivision'] && shipping['address_subdivision'].length != 0)) && (!country.postal_code_required || (shipping['address_postal_code'] && shipping['address_postal_code'].length != 0)) && (shipping['address_mobile_phone_number'] && shipping['address_mobile_phone_number'].length != 0)) {
            <ion-row>
              <ion-col>
                <ion-item lines="none" class="ion-no-padding">
                  <ion-toggle class="form-toggle" alignment="start" label-placement="stacked" [(ngModel)]="add_to_shipping_addresses">Save to address book</ion-toggle>
                </ion-item>
              </ion-col>
            </ion-row>
          }
        </ion-grid>
        <ion-grid class="fieldset">
          <ion-row>
            <ion-col>
              <ion-input type="email" inputmode="email" maxlength="320" labelPlacement="stacked" fill="outline" [(ngModel)]="shipping['shipping_notification_email_address']">
                <div slot="label">Shipping notification email address<ion-text class="optional">optional</ion-text></div>
              </ion-input>
            </ion-col>
          </ion-row>
        </ion-grid>
        <ion-grid class="fieldset">
          <ion-row>
            <ion-col>
              <h3>Gifting</h3>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-item lines="none" class="ion-no-padding">
                <ion-toggle class="form-toggle" alignment="start" label-placement="stacked" [(ngModel)]="shipping['gift']">Gift</ion-toggle>
              </ion-item>
            </ion-col>
          </ion-row>
          @if (shipping['gift'] && shipping['gift'] == true) {
            <ion-row>
              <ion-col>
                <ion-textarea type="text" inputmode="text" maxlength="500" [autoGrow]="true" rows="5" labelPlacement="stacked" fill="outline" [(ngModel)]="shipping['gift_message']">
                  <div slot="label">Gift message<ion-text class="optional">optional</ion-text></div>
                </ion-textarea>
              </ion-col>
            </ion-row>
          }
        </ion-grid>
      </ion-col>
    </ion-row>
  </ion-grid>

</ion-content>